// If you are adding a term to the Action glossary,
// please add a member of the Data team to your PR

export const Action = {
  accepted: 'accepted',
  added: 'added',
  allowed: 'allowed',
  archived: 'archived',
  attached: 'attached',
  blurred: 'blurred',
  cancelled: 'cancelled',
  changed: 'changed',
  checked: 'checked',
  cleared: 'cleared',
  clicked: 'clicked',
  closed: 'closed',
  collapsed: 'collapsed',
  commented: 'commented',
  completed: 'completed',
  confirmed: 'confirmed',
  converted: 'converted',
  copied: 'copied',
  created: 'created',
  deleted: 'deleted',
  denied: 'denied',
  disabled: 'disabled',
  dismissed: 'dismissed',
  downloaded: 'downloaded',
  edited: 'edited',
  enabled: 'enabled',
  entered: 'entered',
  errored: 'errored',
  executed: 'executed',
  expanded: 'expanded',
  exposed: 'exposed',
  failed: 'failed',
  fetched: 'fetched',
  filtered: 'filtered',
  finished: 'finished',
  focused: 'focused',
  hid: 'hid',
  highlighted: 'highlighted',
  hovered: 'hovered',
  initialized: 'initialized',
  inserted: 'inserted',
  installed: 'installed',
  invited: 'invited',
  invoked: 'invoked',
  joined: 'joined',
  left: 'left',
  loaded: 'loaded',
  loggedIn: 'loggedIn',
  mentioned: 'mentioned',
  mounted: 'mounted',
  navigated: 'navigated',
  opened: 'opened',
  ordered: 'ordered',
  pressed: 'pressed',
  processed: 'processed',
  readyForUser: 'readyForUser',
  received: 'received',
  refreshed: 'refreshed',
  removed: 'removed',
  rendered: 'rendered',
  reordered: 'reordered',
  requested: 'requested',
  retrieved: 'retrieved',
  saved: 'saved',
  searched: 'searched',
  selected: 'selected',
  sent: 'sent',
  set: 'set',
  shared: 'shared',
  shown: 'shown',
  skipped: 'skipped',
  starred: 'starred',
  started: 'started',
  stopped: 'stopped',
  submitted: 'submitted',
  subscribed: 'subscribed',
  succeeded: 'succeeded',
  suggested: 'suggested',
  timedOut: 'timedOut',
  toggled: 'toggled',
  transitioned: 'transitioned',
  triggered: 'triggered',
  unchecked: 'unchecked',
  unstarred: 'unstarred',
  unsubscribed: 'unsubscribed',
  updated: 'updated',
  upgraded: 'upgraded',
  uploaded: 'uploaded',
  verified: 'verified',
  viewed: 'viewed',
} as const;

export type ActionType = typeof Action[keyof typeof Action];

export const isValidAction = (a: ActionType) => {
  const validSources = Object.values(Action);
  return validSources.includes(a);
};
